// HID Keyboard Adapter — el lector RFID físico se conecta al sistema operativo como
// un teclado y "tipea" el código del chip seguido de Enter. Este adapter escucha eventos keydown
// y reconstruye el código. Funciona en iOS y Android sin permisos especiales.

export class HIDKeyboardAdapter {
  constructor() {
    this.name = 'Lector HID (teclado)';
    this.status = 'disconnected';
    this.listeners = new Set();
    this.buffer = '';
    this.timer = null;
    this._handler = this._handler.bind(this);
  }

  async isAvailable() {
    return typeof window !== 'undefined';
  }

  async requestDevice() {
    return { id: 'hid', name: 'HID Keyboard' };
  }

  async connect() {
    window.addEventListener('keydown', this._handler);
    this.status = 'connected';
  }

  async disconnect() {
    window.removeEventListener('keydown', this._handler);
    this.status = 'disconnected';
  }

  _handler(e) {
    if (e.key === 'Enter') {
      const chip = this.buffer.replace(/[^0-9]/g, '');
      this.buffer = '';
      if (chip.length >= 10) {
        this.status = 'reading';
        this.listeners.forEach((cb) => cb(chip));
        this.status = 'connected';
      }
    } else if (/^[0-9]$/.test(e.key)) {
      this.buffer += e.key;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => (this.buffer = ''), 500);
    }
  }

  onChipRead(cb) {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }

  getStatus() {
    return this.status;
  }
}
